import * as yup from 'yup';

import { isEmailValid } from '@identity/domain/value-objects';

/** The data of the email form. One field: the address this account will be reachable at. */
export type EmailFormValues = {
  email: string;
};

/** i18n keys that the resolver writes in `errors.email.message` and the component translates. */
export const EMAIL_VALIDATION_KEYS = {
  required: 'validation.email.required',
  invalid: 'validation.email.invalid',
} as const;

/**
 * Validation schema of the email step. It checks the format and nothing else, with the same function
 * the value object uses, so the field and the use case agree on what a valid address is.
 *
 * It never asks whether the address already belongs to somebody: that would turn the field into a
 * detector of registered accounts. The conflict is reported by the send.
 */
export const createEmailFormSchema = () =>
  yup.object({
    email: yup
      .string()
      .required(EMAIL_VALIDATION_KEYS.required)
      .test('email-format', EMAIL_VALIDATION_KEYS.invalid, (value) => isEmailValid(value ?? '')),
  });
